import { h } from "preact";
import { useCallback, useEffect, useState } from 'preact/hooks';
import Button from '@src/components/button';
import cx from 'classnames';
import {If,Else} from "@src/components/if"

import './index.less';

const SendCode = ({ className, children, onClick, disable = false, countDown = 60, type }) => {
  const [lockStatus, setLockStatus] = useState(false);
  const [time, setTime] = useState(countDown);
  const clickHandler = useCallback(e => {
    const handler = async () => {
      if (onClick) {
        const result = await onClick();
        if (result && result.$state === 0) {
          return;
        }
      }
      setLockStatus(true);
    };
    handler().then();
    e.stopPropagation();
  }, []);
  useEffect(
    () => {
      const countDownHandler = time => {
        if (time !== 0) {
          setTimeout(() => {
            setTime(time - 1);
            countDownHandler(time - 1);
          }, 1000);
        } else {
          setLockStatus(false);
          setTime(countDown);
        }
      };
      if (lockStatus) {
        countDownHandler(time);
      }
    },
    [lockStatus]
  );
  return (
    <If condition={!lockStatus}>
      <Button onClick={clickHandler} type={!disable ? type : 'disable'} className={cx('xfe_send_code_root', disable && 'xfe_send_code_disableButton', className)}>
        {children}
      </Button>
      <Else>
        <Button onClick={clickHandler} type={'disable'} className={cx('xfe_send_code_disable', className)}>
          {time}s
        </Button>
      </Else>
    </If>
  );
};

export default SendCode;
